// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blank-toolbar {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/RequestOrder/Components/PbhRequestOrderEdit/PbhRequestOrderEdit.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B","sourcesContent":[".blank-toolbar {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
